import { useRef, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "reactstrap";

//Unform e componentes
import { Form } from "@unform/web";
import UInput from "@/frontend/componentes/unform/UInput";

//Context
import { useAuth } from "@/frontend/context/auth";

//Common
import {
  COD_ERRO_REGRA_NEGOCIO,
  PATH_FERRAMENTA_ADM_SYSTEM,
  SISTEMA_SIGLA,
} from "@/common/constantes";
import { PAGINACAO } from "@/common/utils/paginacao";

//Util
import { fn_ambienteIsDesenvolvimento } from "@/frontend/utils/env";
import { ICONES_ACESSO } from "@/frontend/utils/icones.jsx";
import { fn_validarCamposObrigatorios } from "@/frontend/utils/form";
import { MENSAGENS_ERRO, showMensagemErro } from "@/frontend/utils/mensagens";

//API
import { api_login } from "@/frontend/services/api/api_others";
import { fn_aplicarTema, fn_getTemaTenant } from "@/frontend/utils/tema";

function TLogin_system() {
  const { signIn } = useAuth();

  const navigate = useNavigate();

  //### USE REF ###
  const formRef = useRef(null);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Retira o espaço reservado para o cabeçalho do sistema, que não aparece no login
    document.body.classList.add("login");

    //Aplica o tema do SYstem
    fn_aplicarTema(fn_getTemaTenant(PATH_FERRAMENTA_ADM_SYSTEM));

    const timer = setTimeout(() => {
      //Foco no primeiro campo
      formRef?.current?.getFieldRef("identificacao")?.current?.focus();
    }, 100);
    return () => {
      document.body.classList.remove("login");
      clearTimeout(timer);
    };
  }, []);

  //### FUNÇÕES ###
  function getDadosSessaoUsuario(identificacao, ret) {
    const perfil = ret.usuario.perfil;

    const response = {
      sessaoUsuario: {
        token: ret.token,
        tempo_sessao: ret.tempo_sessao,

        path: ret.path,

        usuario: {
          id: ret.usuario.id,
          id_tenant: null,
          identificacao: identificacao,
          nome: ret.usuario.nome,
          perfil: { id: perfil.id, nome: perfil.nome },
          data_ultimo_login: ret.usuario.data_ultimo_login,
        },

        menus: ret.acesso.menus,
        telas: ret.acesso.telas,

        //Posição do menu (topo ou lateral) da parametrização global
        posicao_menu: ret.params?.posicao_menu,
      },
    };

    return response;
  }

  /*
   * Seta a parametrização de paginação default no escopo global do sistema
   */
  function setParametrizacoes(params) {
    //Inicializa a parametrização da paginação default no login para não precisar buscar a cada consulta
    if (params?.paginacao) {
      PAGINACAO.ITENS_POR_PAGINA_DEFAULT = params.paginacao;
    }
  }

  //### EVENTOS ###
  //SUBMIT - Botão Entrar
  async function handleSubmit(body) {
    try {
      const formValido = fn_validarCamposObrigatorios(formRef, body);
      if (formValido) {
        const ret = await api_login(
          body.identificacao,
          body.senha,
          PATH_FERRAMENTA_ADM_SYSTEM,
        );

        if (ret?.usuario) {
          setParametrizacoes(ret?.params);

          //Loga o usuário no sistema
          const response = getDadosSessaoUsuario(body.identificacao, ret);
          signIn(response);
          navigate("/dashboard_system");
        }
      }
    } catch (error) {
      if (error.response?.status == COD_ERRO_REGRA_NEGOCIO) {
        showMensagemErro(error.response.data);
      } else {
        showMensagemErro(MENSAGENS_ERRO.TENTATIVA_OPERACAO, `logar ${error}`);
      }
    }
  }

  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        {/* Lado esquerdo */}
        <div className="col-8 p-0">
          {/* Em desenvolvimento a imagem é a verde, a cor do tema de desenvolvimento */}
          <img
            src={
              fn_ambienteIsDesenvolvimento()
                ? "/login_adm_dev.svg"
                : "/login_adm.svg"
            }
            //src="/login_adm.svg"
            className="img-login-adm"
          />
        </div>

        {/* Lado direito - LOGIN */}
        <div className="col-4 d-flex justify-content-center align-items-center bg-white">
          <Form ref={formRef} onSubmit={handleSubmit} className="w-75">
            <div className="sistema-sigla sistema-adm">{SISTEMA_SIGLA}</div>

            <div className="text-center sistema-adm mb-4 h4">
              ADMINISTRATIVO
            </div>

            <div className="imagem-tenant-login text-center mt-4">
              <img
                src={
                  fn_ambienteIsDesenvolvimento()
                    ? "/system_adm_dev.svg"
                    : "/system_adm.svg"
                }
                //src="/system_adm.svg"
              />
            </div>

            <div>
              <UInput
                name="identificacao"
                label="Identificação*"
                lowerCase={true}
                icone={ICONES_ACESSO.USUARIO}
              />

              <UInput
                type="password"
                name="senha"
                label="Senha*"
                caseSensitive={true}
                icone={ICONES_ACESSO.SENHA}
              />

              <Button
                type="submit"
                name="btnLogin"
                color="primary"
                className="w-100 mt-3"
              >
                Login
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default TLogin_system;
